
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import config from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
// import speakersData from '@/utils/speakersData'

import PictureViewer from '@/components/PictureViewer.vue'

export default defineComponent({
    computed: {
        ...mapState(['picViewerData'])
    },
    components: {
        PictureViewer
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $router = useRouter()
        const id = Number(useRoute().params.id)
        const currentIndex = ref<number>(0)
        const detailData = $store.state.activityData.templateConfig.speakersData[id]
        const navList = ref<any[]>([
            {
                type: 'live',
                name: '直播',
                list: []
            },
            {
                type: 'report',
                name: '报道',
                list: []
            },
            {
                type: 'pic',
                name: '图片',
                list: []
            },
            {
                type: 'point',
                name: '视频',
                list: []
            },
        ])

        const back = () => {
            $router.replace('/hall')
        }

        const changeNav = (index: number) => {
            currentIndex.value = index
        }

        const goNews = (item) => {
            let href = ''
            if (COVERAPP.Attribute.isApp()) {
                _this.proxy.$http('/wap/getDetail', {
                    eid: item.info.newsid
                }).then((data) => {
                    href = `${config.APP_SCHEME_URL}/news?id=${data.news_id}&flag=${data.flag}`
                    window.location.href = href
                }).catch(() => {
                    COVER.toast('网络错误，请重试')
                })
            } else if (COVERAPP.Attribute.isMb()) {
                const path = item.info.newsType === '视频文章' ? 'video_details.html' : item.info.newsType === '直播文章' ? 'live_casting.html' : 'news_details.html'
                href = `${config.WAP_URL}/${path}?eid=${item.info.newsid}&timestamp=${+new Date()}`
                $router.push({
                    path: '/webview',
                    query: {
                        url: href,
                        id: id
                    }
                })
            } else {
                href = `${config.WEB_URL}/news/${item.info.newsid}`
                window.open(href)
            }
        }

        const handleItem = (item, index) => {
            if (navList.value[currentIndex.value].type !== 'pic') {
                goNews(item)
            } else {

                $store.commit('SET_PICVIEWERDATA', {
                    index,
                    list: navList.value[currentIndex.value].list.reduce((arr, item) => {
                        arr.push({
                            img: item.info.image
                        })
                        return arr
                    }, [])
                })
            }
        }

        const imgCrop = (img: string, type: string) => {
            let w = 0, h = 0
            if (type == 'live') {
                w = 953
                h = 382
            } else {
                w = 490
                h = 368
            }
            if (img.indexOf('?') > 0) {
                if (!/imageView2/.test(img)) {
                    img += '|imageMogr2/auto-orient/thumbnail/!' + w + 'x' + h + 'r/gravity/Center/crop/' + w + 'x' + h;
                }
                if (!/imageslim/.test(img)) {
                    if(type == 'jpg') {
                        img += '/format/jpg|imageslim'
                    } else {
                        img += '|imageslim';
                    }
                }
            } else {
                img += '?imageMogr2/auto-orient/thumbnail/!' + w + 'x' + h + 'r/gravity/Center/crop/' + w + 'x' + h + '|imageslim'
            }
            return img
        }

        const getList = () => {
            _this.proxy.$request('/vote', {
                aid: $store.state.aid,
                page: 1,
                rows: 1000,
                field: 'man',
                keyword: detailData.name,
                sort: 'info.no'
            }).then((data) => {
                data.list.map((val) => {
                    navList.value.map(navV => {
                        if (val.info.type === navV.name) {
                            navV.list.push(val)
                        }
                    })
                })
                if (navList.value[0].list.length > 0 && navList.value[0].list[0].info.newsType === '视频文章') {
                    navList.value[0].name = '讲座实录'
                }
                COVER.pageLoaded() 
            })    
        }

        getList()

        onMounted(() => {
            COVER.track('load', '讲师详情页')
            COVER.onshare($store.state.shareData)
        })    

        return {
            id,
            currentIndex,
            detailData,
            navList,
            back,
            changeNav,
            handleItem,
            imgCrop
        }
    }
})
